module.exports = __webpack_public_path__ + "static/media/dead-santa.d23c4d6d.png";